import 'whatwg-fetch'
import debounce from 'debounce'
import { isVisible, urlFor } from 'radio-components'

class Grid {
  constructor (el){
    this.el = el
    this.pos = 0
  }

  init() {
    if(!this.el || this.el.querySelector('.float-columns')){
      return
    }
    this.loadMoreButton = this.el.nextElementSibling && this.el.nextElementSibling.querySelector('[data-search-more], [data-load-more]')
    this.addWrapperColumns()
    this.addGridItems(this.gridItems())
    this.listenResize()
    this.listenClickLoadMore()
  }

  listenResize(){
    const resize = debounce( () => this.addGridItems(this.gridItems()), 250)

    window.addEventListener("resize", resize)

    window.$(document).one(window.XhrLoader.EVENTS.UNLOAD, () => {
      window.removeEventListener("resize", resize)
    })
  }

  listenClickLoadMore() {
    if(this.loadMoreButton){
      this.loadMoreButton.addEventListener('click', this.fetchMore.bind(this))
    }
  }

  async fetchMore(e){
    e.preventDefault();
    let url
    const lastAddedItem = this.el.querySelector(`[data-pos=${CSS.escape(this.pos - 1)}]`)
    if(lastAddedItem && this.loadMoreButton.dataset.searchQuery){
      url = urlFor({
        q: this.loadMoreButton.getAttribute('data-search-query'),
        after: lastAddedItem.dataset.after,
        limit: 12,
        partial: true
      });
    } else {
      url = urlFor({ 
        since: lastAddedItem.dataset.since
      })
    }

    const response = await fetch(url)
    const html = await response.text()
    const $html = document.createRange().createContextualFragment(html)
    const $parent = $html.querySelector('.c-media-list') || $html

    this.addGridItems($parent.querySelectorAll('.u-grid__item'))
  }

  addWrapperColumns () {
    this.el.appendChild(document.createRange().createContextualFragment(`
      <div class="float-columns">
        <div class="float-column">
        </div>
        <div class="float-column">
        </div>
        <div class="float-column">
        </div>
      </div>
    `))
  }

  gridItems() {
    return Array.from(this.el.querySelectorAll('.u-grid--1\\/3.c-media-list .u-grid__item'))
  }

  orderedGridItems(items) {
    return items.sort((a,b) => {
      const aPos = a.dataset.pos ? parseInt(a.dataset.pos) : items.indexOf(a)
      const bPos = b.dataset.pos ? parseInt(b.dataset.pos) : items.indexOf(b)
      return aPos - bPos
    })
  }

  columns() {
    return Array.from(this.el.querySelectorAll('.c-media-list .float-column')).
      filter((column) => isVisible(column))
  }

  addGridItems(items) {
    items = Array.from(items)
    const currentColumns = this.columns()
    if (!currentColumns.length) { return } // If no columns are visible, don't try to move anything
    this.orderedGridItems(items).forEach( (item) => {
      if(!item.dataset.pos){
        item.dataset.pos = this.pos++
      }
      currentColumns[item.dataset.pos % currentColumns.length].appendChild(item)
    })

    this.toggleSearchMoreButton(items)
  }

  toggleSearchMoreButton(items) {
    if(!this.loadMoreButton){
      return
    }
    if(items && items.length ==0){
      this.loadMoreButton.style.display = 'none';
    }
    if(!this.loadMoreButton.dataset.searchQuery){
      return
    }
    const itemCount = this.el.querySelectorAll('.content-tile').length + 1;

    if (itemCount >= this.loadMoreButton.getAttribute('data-search-total-count')) {
      this.loadMoreButton.style.display = 'none';
    }
  }
}

function initGrid() {
  document.querySelectorAll('.c-media-list').forEach((el) => {
    const grid = new Grid(el)
    grid.init()
  })
}

function init (){
  window.addEventListener('DOMContentLoaded', () => {
    initGrid()
    window.$(document).on(window.XhrLoader.EVENTS.CONTENT_REPLACED, initGrid)
  })
}


export default init;